export enum TaskPredType {
    SS = "SS",
    SF = "SF",
    FS = "FS",
    FF = "FF"
}
